
import script from '/home/circleci/app/components/UserSession';

script();
